export function getCompareColor(color: string): string {
    return `repeating-linear-gradient(45deg, transparent, transparent 1.5px, ${color} 1.5px, ${color} 3px)`;
}
